import { render, staticRenderFns } from "./gtr-user-instructions.vue?vue&type=template&id=5d0594cf"
import script from "./gtr-user-instructions.ts?vue&type=script&lang=ts&external"
export * from "./gtr-user-instructions.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports